/**
 * Providers globales — montados una sola vez en la raíz.
 *
 *   - QueryClientProvider: cache + revalidation para data fetching.
 *   - Toaster (sonner): notificaciones tipo toast en bottom-right.
 *
 * No incluye BrowserRouter — eso vive en router.tsx para poder tener
 * MemoryRouter en tests sin tocar este wrapper.
 */

import { useState, type ReactNode } from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { Toaster } from '@/components/ui/sonner';

interface ProvidersProps {
  children: ReactNode;
}

export function Providers({ children }: ProvidersProps) {
  // useState para que el QueryClient se cree una sola vez por mount del provider
  // (no en cada render). Esto evita problemas con Strict Mode en dev.
  const [queryClient] = useState(
    () =>
      new QueryClient({
        defaultOptions: {
          queries: {
            staleTime: 30 * 1000, // 30s — data del back se considera fresca este tiempo
            retry: 1,
            refetchOnWindowFocus: false,
          },
          mutations: {
            retry: 0,
          },
        },
      }),
  );

  return (
    <QueryClientProvider client={queryClient}>
      {children}
      <Toaster richColors position="bottom-right" />
    </QueryClientProvider>
  );
}
